import { HammerGestureConfig } from "@angular/platform-browser";
import { Injectable } from "@angular/core";

declare var Hammer: any;

@Injectable()
export class HammerConfig extends HammerGestureConfig {
    buildHammer(element: HTMLElement) {
        let mc = new Hammer(element,
            {
                inputClass: Hammer.TouchInput,
                touchAction: "pan-y"
            });

        return mc;
    }
}
